/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './card_data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "PaymentInstrument": {
                "fields": {
                  "cardData": {
                    "type": ".squareup.client.bills.CardData",
                    "id": 1
                  },
                  "storedInstrument": {
                    "type": ".squareup.client.bills.StoredInstrument",
                    "id": 2
                  },
                  "bitcoinLightningInstrumentHackweek": {
                    "type": ".squareup.client.bills.BitcoinLightningInstrument",
                    "id": 3
                  },
                  "squareAccountInstrument": {
                    "type": ".squareup.client.bills.SquareAccountInstrument",
                    "id": 4
                  }
                },
                "nested": {
                  "payment_data": {
                    "oneof": ["cardData", "storedInstrument", "bitcoinLightningInstrumentHackweek", "squareAccountInstrument"]
                  }
                }
              },
              "BitcoinLightningInstrument": {
                "fields": {
                  "invoiceHash": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "StoredInstrument": {
                "fields": {
                  "instrumentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customerToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "contactToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SquareAccountInstrument": {
                "fields": {
                  "squareAccountToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "contactToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StoreAndForwardPaymentInstrument": {
                "fields": {
                  "encryptedPaymentInstrument": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.PaymentInstrument && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.BitcoinLightningInstrument && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.StoredInstrument && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareAccountInstrument && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.StoreAndForwardPaymentInstrument) {
  $root.addJSON(jsonData);
}

/**
 * Authorization specific information for the given tender, only one of these should be set.
 *
 * SOURCE PaymentInstrument @ squareup/client/bills/payment_instrument.proto at 17:1
 */
export const PaymentInstrument = $root.lookupType('squareup.client.bills.PaymentInstrument');
fixType(PaymentInstrument);
Builder.createAndAttachToType(PaymentInstrument);
/**
 * An instrument representing a BTC lightning network payment. Note that this is for hackweek.
 *
 * SOURCE BitcoinLightningInstrument @ squareup/client/bills/payment_instrument.proto at 48:1
 */
export const BitcoinLightningInstrument = $root.lookupType('squareup.client.bills.BitcoinLightningInstrument');
fixType(BitcoinLightningInstrument);
Builder.createAndAttachToType(BitcoinLightningInstrument);
/**
 * Stored instrument corresponding to an instrument in the Instruments service
 *
 * SOURCE StoredInstrument @ squareup/client/bills/payment_instrument.proto at 54:1
 */
export const StoredInstrument = $root.lookupType('squareup.client.bills.StoredInstrument');
fixType(StoredInstrument, {
  instrumentToken: {
    required: true
  },
  contactToken: {
    required: true
  }
});
Builder.createAndAttachToType(StoredInstrument);
/**
 * Instrument corresponding to a Square Account, primarily used by House Accounts.
 * Backed by a buyer financial account that is retrieved using Cardr.
 *
 * SOURCE SquareAccountInstrument @ squareup/client/bills/payment_instrument.proto at 79:1
 */
export const SquareAccountInstrument = $root.lookupType('squareup.client.bills.SquareAccountInstrument');
fixType(SquareAccountInstrument, {
  squareAccountToken: {
    required: true
  },
  contactToken: {
    required: true
  }
});
Builder.createAndAttachToType(SquareAccountInstrument);
/**
 * Encrypted payment instrument used by store-and-forward (offline mode) flow only.
 *
 * SOURCE StoreAndForwardPaymentInstrument @ squareup/client/bills/payment_instrument.proto at 92:1
 */
export const StoreAndForwardPaymentInstrument = $root.lookupType('squareup.client.bills.StoreAndForwardPaymentInstrument');
fixType(StoreAndForwardPaymentInstrument, {
  encryptedPaymentInstrument: {
    required: true
  }
});
Builder.createAndAttachToType(StoreAndForwardPaymentInstrument);